import { AbstractGridListingFilter, type IGridListingFilterValue } from '../grid.listing.filter';

export interface ITimeRange {
    from?: string;
    to?: string;
}

export class TimeRangeGridListingFilter extends AbstractGridListingFilter {
    private postfixFrom = '.from';
    private postfixTo = '.to';

    constructor(
        filterName: string,
        private fieldName: string,
        scopeVariable: ITimeRange,
        private TimeFormatterService: any /*TODO*/,
        private withSeconds
    ) {
        super(filterName, scopeVariable);
    }

    public setPostfix(from: string, to: string) {
        this.postfixFrom = from;
        this.postfixTo = to;
    }

    public values() {
        return [
            {
                name: this.fieldName + this.postfixFrom,
                value: this.value('from')
            },
            {
                name: this.fieldName + this.postfixTo,
                value: this.value('to')
            }
        ];
    }

    public value(variable) {
        let result = undefined;
        if (this.scopeVariable[variable]) {
            result = this.scopeVariable[variable] + (this.withSeconds ? ':00' : '');
        }
        return result;
    }

    public title(name, value) {
        if (value) {
            return this.TimeFormatterService.formatAnyDateTimeString(value);
        }
        return '';
    }

    public descriptions() {
        return (values: IGridListingFilterValue[]) => {
            const titles: string[] = [];
            values.forEach(item => {
                if (item.value) {
                    titles.push(this.title(item.name, item.value));
                }
            });

            return {
                quick: this.quick,
                empty: this.noBottom,
                titles: titles.length ? [titles.join(' - ')] : []
            };
        };
    }

    public isEmpty() {
        let empty = true;
        this.values().forEach(item => {
            empty = empty && (!item.value || item.value === '');
        });
        return empty;
    }

    public clear() {
        this.scopeVariable.from = '';
        this.scopeVariable.to = '';
    }
}
